export default {
  duration: 'Czas trwania',
  recipeStepUp: 'Przesuń krok przepisu w górę',
  recipeStepDown: 'Przesuń krok przepisu w dół',
  recipeStepDuplicate: 'Skopiuj krok przepisu',
};
